<template>
  <div class="row" id="" style="margin-left: 0px; margin-right: 0px;">
    <div class="col-xs-12 app-header">
      <div class="row">
        <div class="col-xs-6">
          <div style="width: 400px; float: left; padding: 20px 0px 0px 0px;color: #FFFFFF;font-size:30px;">
            ソフトウェアライセンス管理
            <br><div style="font-size:20px;color: #FFFFFF">e-sma</div>
          </div>
        </div>
        <div class="col-xs-6 app-header-user option_menu">
          <div style="margin: 0px 10px; float: right;">
            <router-link
            @click.native="onClick"
              to="/logout"
              class="btn btn-xs btn-primary"
              type="button"
              style="margin: 0px 10px; float: right;background-color:#3b89cb;"
              v-if="alloLogout"
              >
              ログアウト
            </router-link>
            <br>
            <br>
            <dropdown v-show="showMenu" text="オプション" type="primary btn  btn-xs btn-primary " >
              <li>
                <a @click="goToBrowserSettings">ブラウザ設定</a>
              </li>
            </dropdown>
          </div>

          <span style="float: right; padding: 8px; font-size: 12px;text-align: end;color: #FFFFFF;">
            <span>{{ userCompany }}</span><br />
            <span >{{ userDepartment }}</span><br />
            <span >{{ userTeam}}</span><br />
            <span >{{ userShimei }}</span><br />
            <span >{{ userRole }}</span>
          </span>
        </div>
      </div>
    </div>
    <div style="padding:10px 0px 0px 20px;">
      <table v-show="showMenu" style="width:100%;" >
        <tr>
          <td style="width:11%;padding:2px 1px; "><router-link
          @click.native="onClick" to="/menu" type="button" style="width: 100%" class="btn btn-primary ">ホーム</router-link></td>
          <td style="width:11%;padding:2px 1px; ">
            <router-link
            @click.native="onClick"
            :disabled="checkHeaderUserPermission(acl.device_embedded_information) == false" tag="button"
            to="/device_embedded_information"
            type="button" style="width: 100%;" class="btn btn-primary ">機器・組込情報</router-link>
          </td>
          <td style="width:11%;padding:2px 1px; ">
            <dropdown text="　　証書　　" type="btn btn-primary menu-dropdown-toggle" style="width: 100%;" class=" " :disabled="certificateLinksDisabled"  >
              <li v-for="o in certificateLinks" :key="o.name" style="margin: 2px -10px 2px 10px;">
                <router-link
                @click.native="onClick"
                :disabled="o.path == '#' || o.disabled" tag="button"
                :to="o.path"
                type="button"
                style="background: #3b89cd;"
                class="btn btn-primary menu_drop_down">{{o.name}}</router-link>
              </li>
            </dropdown>
          </td>
          <td style="width:11%;padding:2px 1px; ">
            <router-link
            @click.native="onClick"
            :disabled="checkHeaderUserPermission(acl.approval_history) == false" tag="button"
            to="/approval_history" type="button" style="width: 100%;" class="btn btn-primary ">申請承認</router-link>
          </td>
        　<td style="width:11%;padding:2px 1px; ">
            <dropdown text="　　棚卸　　" type="btn btn-primary menu-dropdown-toggle" style="width: 100%;" class=" " :disabled="inventoryLinksDisabled"  >
              <li v-for="o in inventoryLinks" :key="o.name" style="margin: 2px -10px 2px 10px;">
                <router-link
                @click.native="onClick"
                :disabled="o.path == '#' || o.disabled" tag="button"
                :to="o.path"
                type="button"
                style="background: #3b89cd;"
                class="btn btn-primary menu_drop_down">{{o.name}}</router-link>
              </li>
            </dropdown>
          </td>
          <td style="width:11%;padding:2px 1px; ">
            <router-link
            @click.native="onClick"
            :disabled="checkHeaderUserPermission(acl.bulk_import) == false && checkHeaderUserPermission(acl.bulk_import2) == false" tag="button"
            to="/bulk_import" type="button" style="width: 100%;" class="btn btn-primary ">一括取込</router-link>
          </td>
          <td style="width:11%;padding:2px 1px; ">
            <dropdown text="　ユーザ　" type="btn btn-primary menu-dropdown-toggle" style="width: 100%;" class=" " :disabled="masterUserDisabled"  >
              <li v-for="o in masterUserLinks" :key="o.name" style="margin: 2px -10px 2px 10px;">
                <router-link
                @click.native="onClick"
                :disabled="o.path == '#' || o.disabled" tag="button"
                :to="o.path"
                type="button"
                style="background: #3b89cd;"
                class="btn btn-primary menu_drop_down">{{o.name}}</router-link>
              </li>
            </dropdown>
          </td>
          <td style="width:11%;padding:2px 1px; ">
            <dropdown text="管理・マスタ" type="btn btn-primary menu-dropdown-toggle" style="width: 100%;" class=" "  :disabled="configurationLinksDisabled" >
              <li v-for="o in configurationLinks" :key="o.name" style="margin: 2px -10px 2px 10px;">
                <router-link
                @click.native="onClick"
                :disabled="o.path == '#' || o.disabled" tag="button"
                :to="o.path"
                type="button"
                style="background: #3b89cd;"
                class="btn btn-primary menu_drop_down">{{o.name}}</router-link>
              </li>
            </dropdown>
          </td>
          <td style="width:11%;padding:2px 1px; ">
            <dropdown text="メンテナンス" type="btn btn-primary menu-dropdown-toggle" style="width: 100%;" class=" maintenance_menu"  :disabled="maintenanceLinksDisabled" >
              <li v-for="o in maintenanceLinks" :key="o.name" style="margin: 2px -10px 2px 10px;">
                <router-link
                @click.native="onClick"
                :disabled="o.path == '#' || o.disabled" tag="button"
                :to="o.path"
                type="button"
                style="background: #3b89cd;"
                class="btn btn-primary menu_drop_down">{{o.name}}</router-link>
              </li>
            </dropdown>
          </td>
        </tr>
      </table>
    </div>
    <information-modal tag="prevendReturnMessage"/>
    <notice-modal stag="processNoticeModalSchedule" />
  </div>

</template>
<script>
import Vue from "vue";
import { bus } from "@/libs/bus";
import moment from "moment";
import { dropdown } from "vue-strap/dist/vue-strap.js";
import { utils } from "@/libs/utils";
import _ from "lodash";
import informationModal from '@/components/modals/information-modal';
import noticeModal from "./modals/notice-modal";
export default {
  components: {
    dropdown,
    "information-modal":informationModal,
    "notice-modal":noticeModal
  },
  data() {
    return {
      show_back: this.no_back !== true,
      schedule_interval:false,
      scheduler_is_listening:false,
      check_idle_inderval:false
    };
  },
  computed: {
    acl(){
      return utils.acl;
    },
    permissionMode(){
      return utils.PERMISSION_MODE;
    },
    maintenanceLinks(){
      return [
        {name:"プログラムとアクセス権限",path:"/programs_and_permissions", disabled:this.checkHeaderUserPermission(this.acl.maintenance) == false},
        {name:"会社",path:"/master_company", disabled:this.checkHeaderUserPermission(this.acl.maintenance) == false},
        {name:"システム設定",path:"/system_setting", disabled:this.checkHeaderUserPermission(this.acl.maintenance) == false},
        {name:"旧データ取込",path:"old_bulk_import", disabled:this.checkHeaderUserPermission(this.acl.maintenance) == false},
        ]
    },
    maintenanceLinksDisabled(){
      var ret = true;
      this.maintenanceLinks.forEach(e=>{
        if(e.disabled == false){
          ret = false
        }
      })
      return ret;
    },
    masterUserLinks(){
      return [
        {name:"パスワードの変更",path:"/master_change_password", disabled:this.checkHeaderUserPermission(this.acl.master_user_password) == false},
        {name:"ユーザ一覧",path:"/master_user", disabled:this.checkHeaderUserPermission(this.acl.master_user) == false},
        ]
    },
    masterUserDisabled(){
      var ret = true;
      this.masterUserLinks.forEach(e=>{
        if(e.disabled == false){
          ret = false
        }
      })
      return ret;
    },
    configurationLinks(){
      return [
        {name:"部署・チーム",path:"/master_belongs", disabled:this.checkHeaderUserPermission(this.acl.master_bel_mak_sys,this.permissionMode.BROWSE) == false},
        {name:"システム",path:"/master_system", disabled:this.checkHeaderUserPermission(this.acl.master_bel_mak_sys,this.permissionMode.BROWSE) == false},
        {name:"メーカ",path:"/master_maker", disabled:this.checkHeaderUserPermission(this.acl.master_bel_mak_sys,this.permissionMode.BROWSE) == false},
        {name:"ソフトウェア",path:"/master_software", disabled:this.checkHeaderUserPermission(this.acl.master_bel_mak_sys,this.permissionMode.BROWSE) == false},
        //{name:"PWロック解除",path:"/pw_approval_history", disabled:this.checkHeaderUserPermission(this.acl.master) == false || utils.constants.COMPANY.ALL != Vue.localStorage.get("selectedCompany")},
        {name:"メールメッセージ",path:"/mail_message", disabled:this.checkHeaderUserPermission(this.acl.master) == false},
        {name:"お知らせ",path:"/notice", disabled:this.checkHeaderUserPermission(this.acl.master) == false},
        {name:"預り証出力",path:"/deposit_certificate_output", disabled:this.checkHeaderUserPermission(this.acl.master) == false},
        {name:"過不足集計表",path:"/excess_deficiency_summary", disabled:this.checkHeaderUserPermission(this.acl.master) == false},
        {name:"棚卸報告年度区分",path:"/inventory_reporting_period", disabled:this.checkHeaderUserPermission(this.acl.master) == false},
        ]
    },
    configurationLinksDisabled(){
      var ret = true;
      this.configurationLinks.forEach(e=>{
        if(e.disabled == false){
          ret = false
        }
      })
      return ret;
    },
    certificateLinks(){
      return [
        {name:"証書情報",path:"/certificate", disabled:this.checkHeaderUserPermission(this.acl.certificate_software) == false},
        {name:"余剰ライセンス",path:"/surplus_license", disabled:this.checkHeaderUserPermission(this.acl.surplus_license) == false},
        // {name:"証書情報(old)",path:"/certificate_information", disabled:this.checkHeaderUserPermission(this.acl.certificate_information) == false},
        ]
    },
    inventoryLinks(){
      return [
        {name:"棚卸業務",path:"/inventory", disabled:this.checkHeaderUserPermission(this.acl.inventory_report) == false},
        {name:"棚卸報告確認",path:"/inventory_report_check", disabled:this.checkHeaderUserPermission(this.acl.inventory_report_check) == false},
        ]
    },
    certificateLinksDisabled(){
      var ret = true;
      this.certificateLinks.forEach(e=>{
        if(e.disabled == false){
          ret = false
        }
      })
      return ret;
    },
    inventoryLinksDisabled(){
      var ret = true;
      this.inventoryLinks.forEach(e=>{
        if(e.disabled == false){
          ret = false
        }
      })
      return ret;
    },
    userDepartment() {
      return Vue.localStorage.get("userDepartment") || "";
    },
    userTeam() {
      return Vue.localStorage.get("userTeam") || "";
    },
    userShimei() {
      return Vue.localStorage.get("userShimei") || "";
    },
    userRole() {
      return Vue.localStorage.get("userRole") || "";
    },
    userCompany() {
      return Vue.localStorage.get("userCompany") || "";
    },

    loggedUser() {
      return utils.getLoggedUserDisplay();
    },
    allowMenu() {
      var res = this.no_back !== "true";
      return res;
    },
    alloLogout() {
      var res = this.no_logout !== "true";
      return res;
    },
    allowSettigns() {
      var res = typeof this.$props.settings != "undefined";
      return res;
    },
    showMenu() {
      var res = typeof this.$props.no_menu != "undefined" && this.$props.no_menu == "true";
      return res == false;
    },
    getBreadcrumb() {
      // return this.$props.breadcrumb;
      return _.initial(this.$props.breadcrumb);
    },
    getBreadcrumbLast() {
      console.log(
        "getBreadcrumbLast",
        this.$props.breadcrumb[this.$props.breadcrumb.length - 1]
      );
      return [this.$props.breadcrumb[this.$props.breadcrumb.length - 1]];
    },
    getSettingsOptions() {
      var arr = [
        { val: "fixTerminalStatus", label: "Fix Terminal Status" },
        { val: "systemInfo", label: "システム情報" },
        { val: "systemZoom", label: "ページサイズ" },
        { val: "clear", label: "クリア" },
        { val: "reload", label: "リロード" },
        { val: "test", label: "テスト" },
        { val: "import", label: "データ取込" },
        { val: "export", label: "データ出力" },
      ];
      var settings = this.$props.settings || "";
      var allowed = settings.split(",");
      var ret = [];
      arr.forEach((v) => {
        if (allowed.indexOf(v.val) > -1) {
          ret.push(v);
        }
      });
      return ret;
    },
  },
  methods: {
    onClick(){
      console.log('TEST DEBUG 210606 (303 at header.vue)[02:37]: ',this.$route.fullPath );
      if(this.$route.fullPath != "/approval_history"){

        bus.$emit("onSearchClear","header");
      }
    },
    goToBrowserSettings(){
      window.sessionStorage.setItem('broser_setting_back_to',this.$route.fullPath)
      this.$router.push("/browser_setting");
    },
    checkHeaderUserPermission(page_acl, permission = utils.PERMISSION_MODE.BROWSE, requester = ""){
      return utils.check_user_permission(page_acl,permission,requester)
    },

    onClickBreadcrumbLast() {
      window.location.reload();
    },
    onMenuClick(target, mode) {
      if (mode.val == "systemZoom") {
        this.$router.push({ name: "Page24_page_zoom" });
      } else {
        this.$emit(
          "on" + mode.val.charAt(0).toUpperCase() + mode.val.slice(1),
          target
        );
      }
    },
    prevent_return(){

      bus.$emit("prevendReturnMessage",{
        // title: "本操作は行うことができません。",
        message: "本操作は行うことができません。",
        yes_label: "OK",
        large:false
      });

      // alert("本操作は行うことができません。")
      history.pushState(null, document.title, location.href);
    },
    prevent_reload(e) {
      var confirmationMessage = "このサイトを再度読み込みしますか？\n行った変更が保存されない可能性があります。";
      (e || window.event).returnValue = confirmationMessage;     // Gecko + IE
      return confirmationMessage;                                /* Safari, Chrome, and other
                                                                  * WebKit-derived browsers */
    },
    check_invalid_2tabs(){
      var devMode2 = Vue.localStorage.get('devMode2') || 0;
      if(devMode2 != 1){
        var ss = window.sessionStorage.getItem('browser_tab_id') || false;
        var ls = Vue.localStorage.get('browser_tab_id') || false;
        if(ls == false || ss == false || ls != ss){
          window.sessionStorage.setItem('browser_tab_id',false)
          Vue.localStorage.set('browser_tab_id',false);
          return this.$router.push({ name: "page_0060_redirect", params: {
            url:"/logout/duo",
            message:"重複して起動されたため、強制ログアウトをします。",
            wait:1000
          }});
        }else{
        }
      }
    },
    prevent_2tabs(ev){
      if(ev.key == "browser_tab_id"){
        this.check_invalid_2tabs();
      }
    },
    // checkNoticiesForSchedule(){
    //   var noticiesForSchedule = Vue.localStorage.get("noticiesForSchedule")
    //   console.log('TEST DEBUG 210428 (335 at header.vue)[23:58]: ', { noticiesForSchedule });
    //   if(noticiesForSchedule && noticiesForSchedule.length > 8){
    //     noticiesForSchedule = JSON.parse(noticiesForSchedule);
    //     console.log('TEST DEBUG 210428 (338 at header.vue)[23:58]: ', { noticiesForSchedule });
    //     if(this.schedule_interval == false){
    //       this.schedule_interval = []
    //     }else if( Array.isArray(this.schedule_interval) && this.schedule_interval.length > 0){
    //       this.schedule_interval.forEach(cancel_time =>{
    //         clearTimeout(cancel_time);
    //       });
    //     }
    //     noticiesForSchedule.forEach(time =>{
    //       var wait_seconds = moment(time).diff(new Date(),"seconds");
    //       console.log('TEST DEBUG 210428 (348 at header.vue)[23:58]: ', {  wait_seconds});
    //       if(wait_seconds > 0){
    //         console.log(' (210428) Setup timer for',time,'in',wait_seconds,'seconds');
    //         this.scheduler_is_listening = true;
    //         this.schedule_interval.push(setTimeout(()=>{
    //           return bus.$emit("processNoticeModalSchedule",{});
    //         },wait_seconds * 1000 ))
    //       }
    //     })
    //   }
    // }
  },
  mounted(){
    // var max_idle_timeout = 1000 * 30;
    window.sessionStorage.setItem('last_event_time', (new Date()).getTime())
    var max_idle_timeout = 1000 * 60 *  30;
    this.check_idle_inderval = setInterval(()=>{
      if (location.hash != '#/expired' && location.hash != '#/logout' && location.hash != '#/') {
        var now = new Date().getTime();
        var last_event = parseInt(window.sessionStorage.getItem('last_event_time') || now);
        var print_now = moment(now).format("HH:mm:ss")
        var idle = now - last_event;
        if (idle > max_idle_timeout) {
          if((Vue.localStorage.get('devMode2') || 0)==1) {
            console.log('DO NOT EXIRE DUE DEV FALG');
            return;
          };
          window.sessionStorage.setItem('last_event_time', new Date().getTime());
          this.$router.push('/expired');
          console.log(print_now,'TEST DEBUG 210513 HEADER TIMEOUT');
        }
        //console.log(print_now, 'TEST DEBUG 210513 HEADER Event: ', "idle:", parseInt(idle / 1000), "max_idle_timeout:", parseInt(max_idle_timeout / 1000) , " wait:", parseInt((max_idle_timeout - idle) / 1000) );
      }else{
        console.log('TEST DEBUG HEADER LOGED OUT');
      }
    },5000)
    // document.querySelectorAll(".container")[0].style.zoom = localStorage.getItem("pageContainerSize") || 1420;
    var devMode2 = Vue.localStorage.get('devMode2') || 0;
    if(devMode2 != 1){
      history.pushState(null, document.title, location.href);
      history.pushState(null, document.title, location.href);
      window.addEventListener('popstate', this.prevent_return);
      window.addEventListener("beforeunload", this.prevent_reload);
      window.addEventListener("storage", this.prevent_2tabs);
      this.check_invalid_2tabs();
    }
    // this.checkNoticiesForSchedule()
    // if(this.$props.delay_check_noticies_for_schedule == "true"){
    //   setTimeout(() => {
    //     var noticiesForSchedule = Vue.localStorage.get("noticiesForSchedule")
    //     console.log('TEST DEBUG 210428 (375 at header.vue)[00:09]: ', {  noticiesForSchedule ,scheduler_is_listening:this.scheduler_is_listening});
    //     if(noticiesForSchedule && noticiesForSchedule.length > 8 && this.scheduler_is_listening != true){
    //       this.checkNoticiesForSchedule()
    //     }
    //     console.log('TEST DEBUG 210428 (379 at header.vue)[00:11]: ', {  });
    //     setTimeout(() => {
    //       var noticiesForSchedule = Vue.localStorage.get("noticiesForSchedule")
    //       console.log('TEST DEBUG 210428 (381 at header.vue)[00:10]: ', { noticiesForSchedule });
    //       if(noticiesForSchedule && noticiesForSchedule.length > 8 && this.scheduler_is_listening != true){
    //         this.checkNoticiesForSchedule()
    //       }
    //       console.log('TEST DEBUG 210428 (386 at header.vue)[00:11]: ', {  });
    //       setTimeout(() => {
    //         var noticiesForSchedule = Vue.localStorage.get("noticiesForSchedule")
    //         console.log('TEST DEBUG 210428 (387 at header.vue)[00:10]: ', { noticiesForSchedule });
    //         if(noticiesForSchedule && noticiesForSchedule.length > 8 && this.scheduler_is_listening != true){
    //           this.checkNoticiesForSchedule()
    //         }
    //       }, 3000);
    //     }, 2000);
    //   }, 1000);
    // }
  },
  beforeRouteLeave (to, from, next) {
    console.log('TEST DEBUG 210528 (434 at header.vue)[00:25]: ', { to, from });
    next()
  },
  beforeDestroy(){
    if(this.check_idle_inderval){
      clearInterval(this.check_idle_inderval)
    }
    // if( Array.isArray(this.schedule_interval) && this.schedule_interval.length > 0){
    //   this.schedule_interval.forEach(time =>{
    //     clearTimeout(time);
    //   });
    // }
    window.removeEventListener('popstate', this.prevent_return);
    window.removeEventListener("beforeunload", this.prevent_reload);
    window.removeEventListener("storage", this.prevent_2tabs);
  },
  props: ["no_back", "breadcrumb", "no_logout", "settings","no_menu","delay_check_noticies_for_schedule"],
};
</script>
<style>
  .menu-dropdown-toggle{
    width: 100%!important;
      margin-left: -10px!important;
      background-color: #3b89cb;
  }
  ul.dropdown-menu{
  padding: 0px!important;
  }
  .option_menu > div > div > .dropdown-menu{
 left:-50px;
}
.maintenance_menu  > .dropdown-menu{
 left:-50px;
}

</style>

<style scoped>
.menu_drop_down{
  width:100%;
  color:white;
  border-radius: 0px!important;
}
.menu_drop_down:hover{
  color:#003cb3;
  font-weight: 700;
}
.menu-dropdown-toggle{
  width: 100%!important;
    margin-left: -10px!important;
}
.lams-logo {
  height: 65px;
}
.app-header {
  background: #5b9bd5;
  padding: 5px 30px;
  font-weight: 900;
  color: black;
  text-align: left;
  font-size: 20px;
}
.app-header-user {
  float: right;
  font-size: 14px;
}

.btn-primary {
  margin: 0px 10px;
  float: right;
  background-color: #3b89cb;
  /*border-color: #003cb3;*/
}

.breadcrumb {
  margin-top: 5px;
  _margin-left: 20px;
  padding: 0px 22px;
}

.breadcrumb > li + li:before {
  content: ">";
}

.btn-group {
  float: right;
}


</style>



// WEBPACK FOOTER //
// header.vue?0db8ba20